/* eslint-disable import/prefer-default-export */

export const makePhoneNumber = ({ country, phone }) =>
  `${country}${phone
    .replace('(', '')
    .replace(')', '')
    .replace('-', '')
    .replace(' ', '')}`;

export const showPhoneNumber = phone => {
  try {
    let newPhone = phone.substr(3, phone.length);
    newPhone = `${phone.substr(0, 3)}  (${newPhone.substr(0, 2)}) ${newPhone.substr(2, 5)}-${newPhone.substr(
      7,
      phone.length,
    )} `;
    return newPhone;
  } catch (error) {
    return phone;
  }
};

export const zipcodeMask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
export const phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
